/* Application: Donations
 ========================================================================== */

app.donations = function () {
    'use strict';

    template.donation_option();
};
